import LS from "../../helpers/localStorage";

export default {
  view: "",
  isAtril: false,
  previousView: "",
  previousViewTwo: "",
  showAuth: false,
  HorarioOutContinue: false,
  charging: false,
  error: null,
  tramite_info: {
    queueId: "idSASASASXX2C12",
    branchId: "5a46d454da6a6",
    params: {}
  },
  tramiteInUserEvaluation: null,
  tramiteByDefault: null,
  validationErrors: [],
  errorValidationTemporizer: null,
  currentUser: LS.getItem("currentUser") || null,
  servicioSelected: null,
  selectedAccion: null,
  turn: null,
  time_received_turn: undefined,
  catch_all: null,
  priority: false,
  history: [],
  menu: [],
  actions: null,
  tipide: [
    // { value: null, text: "Seleccione una opción" },
    { value: "CC", text: "Cédula de Ciudadanía" },
    { value: "TI", text: "Tarjeta Identidad" },
    { value: "RC", text: "Registro Civil" },
    { value: "CE", text: "Cedula de Extranjería" },
    { value: "NU", text: "Numero Único de Identificación" },
    { value: "PA", text: "Pasaporte" },
    { value: "AS", text: "Adulto Sin Identificación" },
    { value: "CD", text: "Carné Diplomático" },
    { value: "CN", text: "Certificado de Nacido Vivo" },
    { value: "CO", text: "Código" },
    { value: "IN", text: "N.I.T. NATURAL" },
    { value: "MS", text: "Menor Sin Identificación" },
    { value: "NI", text: "N.I.T." },
    { value: "PD", text: "Pasaporte Diplomático" },
    { value: "PE", text: "Permanencia Especial" },
    { value: "RM", text: "Registro Médico" },
    { value: "TE", text: "Tarjeta de Extranjería" }
  ],
  citas: [],
  citaActual: null,
  currentValidation: [],
  currentSite: null,
  userDemo: [
    {
      NumeroIdentificacion: "456"
    },
    {
      NumeroIdentificacion: "789"
    }
  ],
  queueList: [],
  customArea: null,
  sites: [],
  primaryColorBlue: null,
  secondColorBlue: null,
  threeColorBlueColor: null,
  userActionDate: Date.now(),
};
